import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import SolarReportCard from "../../components/SolarReportCard";
import { useRouter } from "../../util/router";
import { useReportsData } from "../../util/hooks/useReportsData";
import PageLoader from "../../components/PageLoader";
import NotFound from "../../components/NotFound";
import "./styles.scss";

const SolarReport = () => {
  const router = useRouter();

  const {
    match: {
      params: { reportId },
    },
  } = router;

  const [loading, setLoading] = useState(true);
  const reportsData = useReportsData(reportId, "solar");

  useEffect(() => {
    reportsData && setLoading(false);
  }, [reportsData]);

  return (
    <>
      {!loading ? (
        <>
          {reportsData.status && reportsData.data.report_type === "solar" ? (
            <Container fluid className="solar-report-page">
              <SolarReportCard report={reportsData.data} />
            </Container>
          ) : (
            <NotFound message={reportsData.message} />
          )}
        </>
      ) : (
        <PageLoader />
      )}
    </>
  );
};

export default SolarReport;
